/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { ClearableSearchField } from "components/SearchField/SearchField";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import {
  deleteStandardFeatureRecords,
  fetchStandardFeatures,
} from "utils/superAdminApi";

let searchParameter = "";
let featureStatus = "Active";
let LOGIN_DETAILS;

function StandardFeatures() {
  const [customerReload, setCustomerReload] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [rows, setRows] = useState([]);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const dispatch = useDispatch();

  const [values, setValues] = React.useState({
    _id: [],
    sortingType: "",
    sortingField: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    featureType: "Count Based",
    featureName: "",
    featureSequence: 0,
    featureStatus: "All",
    initialValue: "",
    finalValue: "",
    defaultBusinessStandardPlanFeature: "",
    searchParameter: "",
    searchParameterList: [
      "featureName",
      "featureType",
      "featureSequenceString",
      "featureStatus",
    ],
  });

  useEffect(() => {
    (async () => {
      await getRight();
      await fetchStandardData();
    })();
  }, [values.featureStatus, values.sortingType, perPage, dispatch]);

  useEffect(() => {
    if (values.filterValues.length == "") {
      fetchStandardData();
    }
  }, [values.filterValues]);

  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDeleteDialogeClick = async (_id) => {
    values._id = [];
    values._id.push(_id);
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDelete = async (id) => {
    deleteStandard();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = (page) => {
    values.page = page;
    fetchStandardData();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const deleteStandard = async () => {
    await deleteStandardFeatureRecords(
      values,
      (data) => {
        fetchStandardData();
        setTitle("");
        showResMsg(
          data.Result_Status ? genericMessage.deleted : data.Result_Message,
          1000,
          data.Result_Status
        );
      },
      dispatch
    );
  };

  async function getRight() {
    let right = await getScreenRight("Standard Plan Features");
    if (right === "Full Access") {
      setDisableColor(false);
    } else setDisableColor(true);
  }

  const changeCustomerReload = () => {
    setCustomerReload(!customerReload);
  };

  useEffect(() => {
    featureStatus = values.featureStatus;
    changeCustomerReload();
  }, [values.featureStatus]);

  const fetchStandardData = async () => {
    values.searchParameter = searchParameter;
    values.featureStatus = featureStatus;

    await fetchStandardFeatures(
      values,
      (data) => {
        setTotalRows(data.Result_Output.totalDocs);
        setRows(data.Result_Output.docs);
      },
      dispatch
    );
  };

  let columns = [
    {
      name: "Feature Name",
      selector: (row) => row.featureName,
      sortable: true,
      sortField: "featureName",
      left: true,
    },
    {
      name: "Feature Type",
      selector: (row) => row.featureType,
      sortable: true,
      sortField: "featureType",
      center: true,
    },
    {
      name: "Feature Sequence",
      selector: (row) => row.featureSequence,
      sortable: true,
      sortField: "featureSequence",
      center: true,
    },

    {
      // name: "Status",
      name: <p style={{ paddingLeft: "12px" }}>Status</p>,
      selector: (row) => row.featureStatus,
      sortable: true,
      sortField: "featureStatus",
      center: true,
    },
    {
      name: "Actions",
      selector: (row) => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item>
              <Link to={`/standardFeatures/edit/${row._id}`}>
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar screenName={"Standard Features"} />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName="Standard Features" />
          <Grid
            container
            display={"flex"}
            justifyContent="end"
            mt={2.2}
            gap={2}
            px={2.2}
          >
            <Grid lg={2.5} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "44.11px" }}
                  label="Filter By Status"
                  value={values.featureStatus}
                  onChange={(e) =>
                    setValues({ ...values, featureStatus: e.target.value })
                  }
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <ClearableSearchField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchStandardData();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <Button
                        style={{
                          borderRadius: "0px 0.5rem  0.5rem 0px",
                          boxShadow: "none",
                          background: barColor,
                        }}
                        variant="contained"
                        onClick={fetchStandardData}
                      >
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <CardContent>
            <BTable
              title={title}
              columns={columns}
              data={rows}
              selectableRows={false}
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}
            />
          </CardContent>
        </Card>
      </div>
      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
    </DashboardLayout>
  );
}

export default StandardFeatures;
